import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { RosterRunHistory } from "@app/models/rest/roster/roster-run-history";

@Injectable({
  providedIn: "root"
})
export class RosterRunHistoryRestService extends HateoasResourceOperation<RosterRunHistory> {
  constructor() {
    super(RosterRunHistory);
  }
}
